import { NodeData } from "../pages/CampaignPage";

/**
 * Returns a copy of node data with the subject set to `value`, targeting the
 * event-based (`alternateSubject`) or regular (`subject`) field. Shared by both
 * campaign editors' subject `onChange` handlers so the branching lives once.
 */
export const setSubjectOnNodeData = (
	data: NodeData,
	value: string,
	eventBasedState: boolean
): NodeData =>
	eventBasedState ? { ...data, alternateSubject: value } : { ...data, subject: value };
